import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../services/Security/auth.service';

@Component({
  template: '',
  standalone: false,
})
export class CallbackComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.handleAuthentication();
  }
}
